import { Button, Stack } from 'rsuite';
import {
  useAppSelector,
  useLazyGetDemoInstanceAccessUrlQuery,
  useRegionLoginQuery
} from '@monorepo/shared';
import { useCallback, useEffect, useState } from 'react';
import { selectRegions } from '@monorepo/shared/store/authSlice';
import { redirectVmUrl } from '@monorepo/shared/components/InstanceActions';
import FsocIcon from '../../images/account/FortiSOC-white .svg';

interface IProps {
  instance: Record<string, any>;
}
export const DemoInstance = ({ instance }: IProps) => {
  const [getDemoInstanceUrl] = useLazyGetDemoInstanceAccessUrlQuery();

  const [region, setRegion] = useState<Record<string, any>>({});

  const regions = useAppSelector(selectRegions);

  const { data: regionLogin, isSuccess: isRegionLoginSuccess } =
    useRegionLoginQuery(
      {
        region,
        enableTimezone: true
      },
      { skip: !region.url || region.token }
    );

  const onClick = useCallback(async () => {
    if (regionLogin?.token || region?.token) {
      const urlObj = await getDemoInstanceUrl({
        instance: instance,
        region: { ...region, token: regionLogin?.token || region.token }
      }).unwrap();
      if (!urlObj?.url) {
        throw new Error('Instance URL is missing');
      }

      const success = redirectVmUrl(urlObj, '_self');
      if (!success) {
        throw new Error('Failed to redirect to VM URL');
      }
    }
  }, [regionLogin, region]);

  useEffect(() => {
    if (instance?.region_alias && regions[instance?.region_alias]) {
      setRegion(regions[instance?.region_alias]);
    }
    // setRegion({ url: instance?.region_url, alias: instance?.region_alias });
  }, [instance]);
  return (
    <div className="demo-instance-container">
      <Stack spacing={'30px'} alignItems="flex-start">
        <Stack.Item>
          <img src={FsocIcon} className="service-icon" />
        </Stack.Item>
        <Stack.Item flex={1}>
          <div
            className="info-row"
            style={{ maxWidth: '400px', color: '#B0B0B0' }}
          >
            <div
              className="service-title"
              style={{
                marginTop: '10px',
                color: '#B0B0B0'
              }}
            >
              {'Try FortiSOC — No License Required'}
            </div>
            <p className="info-row">
              {'Explore the full FortiSOC experience with a read-only demo.'}
              <br />
              {'Browse live dashboards, case workflows, and AI-driven'}
              <br />
              {'analytics — no commitment needed.'}
            </p>

            <ul
              style={{
                marginTop: '20px',
                marginBottom: '10px',
                paddingLeft: '20px'
              }}
            >
              <li>Full dashboards, cases, and analytics</li>
              <li>Pre-loaded with realistic SOC threat scenarios</li>
              <li>No setup, sign-up, or credit card required</li>
            </ul>
            <Button
              appearance="primary"
              onClick={() => {
                onClick();
              }}
              style={{
                marginTop: '20px',
                width: '180px'
              }}
            >
              {'Launch the Demo'}
            </Button>
          </div>
        </Stack.Item>
      </Stack>
    </div>
  );
};
